import { Offer } from '../types';

export const formattedAmount = (num?: string | number) => {
  if (typeof num === 'undefined' || num === null) return '';
  let value: any = Math.round(Number(num)).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return value.split('.')[0];
};

export const getRenewalProbabilityColor = (renewProb: number) => {
  switch (true) {
    case renewProb > 0 && renewProb <= 64.83:
      return 'red';
    case renewProb > 64.83 && renewProb <= 72.55:
      return 'purple';
    case renewProb > 72.55 && renewProb <= 100:
      return 'green';
    default:
      return 'red';
  }
};

export const getStickinessScoreColor = (score: number) => {
  if (score === 0) return 'red';
  if (score === 1) return 'orange';
  if (score === 2) return 'lightgreen';
  if (score === 3) return 'green';
  if (score === 5) return '#5bc3fe';
};

export const getProposedOffer = (offers: Offer[]) => {
  if (!offers || offers.length === 0) return null;
  offers.sort((a: Offer, b: Offer) => b.Term - a.Term);
  return offers[0];
};

export const getChange = (proposedRent: string, currentRent: string) => {
  let change =
    ((parseInt(proposedRent) - parseInt(currentRent)) / parseInt(currentRent)) *
    100;
  if (isNaN(change) || !isFinite(change)) return 'NA';
  else return change.toFixed(1) + '%';
};

export const getSegementationFromScore = (score: number) => {
  switch (score) {
    case 3:
      return 'A1';
    case 2:
      return 'A2';
    case 1:
      return 'B1';
    case 0:
    default:
      return 'B2';
  }
};

export const validateEmail = (email?: string) => {
  let error = null;
  if (!email) {
    error = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
    error = 'Invalid email address';
  }
  return error;
};

export function sanitizeText(inputString: string) {
  // Remove special characters except "-" using regular expression
  const cleanedString = inputString.replace(/[^\w\s-]/g, '');

  // Replace spaces with "_"
  const processedString = cleanedString.replace(/\s+/g, '_');

  // Convert the string to lowercase
  const lowercaseString = processedString.toLowerCase();

  return lowercaseString;
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const checkMarketRentUpdateRoles = (user: any) => {
  if (!user) return true;

  if (user.isAdmin) return false;
  else if (user.roles.includes('revenueManager')) return false;

  return true;
};
